module.exports = __webpack_public_path__ + "img/at-warehouse.74cdf811.svg";